import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/novelcraft/tek_img_03.webp";
function Solutions() {
  return (
    <section
      className="sol_sec_novel"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="text-center">
            <h2>Travis</h2>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Solutions;
